// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_93444fe79c--switch--CQEnX","indicator":"_93444fe79c--indicator--kueqN","label":"_93444fe79c--label--hfzMb"};